let deferredScheduleHashFullPath = null;

const setDeferredScheduleHashScroll = (fullPath, shouldDefer) => {
  if (shouldDefer && (typeof fullPath !== "string" || !fullPath)) {
    throw new TypeError("A route fullPath is required for deferred scrolling.");
  }

  deferredScheduleHashFullPath = shouldDefer ? fullPath : null;
};

const consumeDeferredScheduleHashScroll = (fullPath) => {
  if (deferredScheduleHashFullPath !== fullPath) {
    return false;
  }

  deferredScheduleHashFullPath = null;
  return true;
};

export {
  consumeDeferredScheduleHashScroll,
  setDeferredScheduleHashScroll,
};
